<div class="flex">
  <div class="login-content">
    <div class="login-container">
      <h2 class="login-title">InnovaTransit</h2>
      <p class="login-subtitle">Primeiro acesso no Servidor</p>
      <!--<ion-item>
          <ion-input
            [(ngModel)]="urlServidor"
            name="urlServidor"
            label="Insira a URL"
            labelPlacement="floating"
            placeholder="Insira a URL contendo o protocolo, IP e porta"
            required
          ></ion-input>
        </ion-item>-->
      <ion-item>
        <ion-select [(ngModel)]="urlServidor" name="urlServidor" label="Selecione o servidor" labelPlacement="floating"
          placeholder="Escolha o servidor" required>
          <ion-select-option value="https://backp.rapidoaraguaia.com.br:8082/api">
            Rapido Araguaia
          </ion-select-option>
          <!--<ion-select-option value="https://apih.araguarina.com.br:8082/api">
            TESTE Araguarina
          </ion-select-option>
          <ion-select-option value="https://i9fluir.com.br:8083/api">
            Metrobus
          </ion-select-option>
          <ion-select-option value="http://localhost:8082/api">
            Testes interno
          </ion-select-option>-->
        </ion-select>
        <!--https://i9fluir.com.br:8083/api  https://api.rapidoaraguaia.com.br:8082/api  http://localhost:8082/api https://i9fluir.com.br:8082/api-->
      </ion-item>

      <ion-toast [isOpen]="showToast" position="top" [message]="toastMessage" duration="3000"
        (didDismiss)="showToast = false">
      </ion-toast>
      <ion-button expand="full" (click)="onSubmit()" class="login-button">Conectar</ion-button>
    </div>
  </div>
</div>